const AchievementsList = [
  {
    id: 1,
    competitionName: "Decode Derby",
    year: "2025",
    rank: "1st Place",
    skillsRequired: ["C", "JAVA", "Problem Solving", "Algorithms", "Data Structures"],
    category: "Competitive Programming",
    description: "Solved the problem statements with optimal solutions in a limited time frame, demonstrating strong coding skills and algorithmic thinking.",
    certificateImage: "/assets/achievements/decodeDerby.jpg",
    status: "Winner"
  },
  {
    id: 2,
    competitionName: "App Genius",
    year: "2025",
    rank: "3rd Place",
    skillsRequired: ["React-Native", "APP Development", "API Development"],
    category: "Mobile App Development",
    description: "Built a comprehensive mobile application with features to determine eco-friendly products and promote sustainable living.",
    certificateImage: "/assets/achievements/appDesign.jpg",
    icon: "🥉",
    status: "Third Place"
  },
  {
    id: 3,
    competitionName: "Dynamic Web Design",
    year: "2024",
    rank: "2nd Place",
    skillsRequired: ["React", "SEO", "Social Impact", "UI/UX"],
    category: "Web Development",
    description: "Created a single-page application for mental health awareness.",
    certificateImage: "/assets/achievements/dynamicWeb.jpg",
    status: "Runner-up"
  },
  {
    id: 4,
    competitionName: "Game Craft ",
    year: "2026",
    rank: "3rd Place",
    skillsRequired: ["Unity", "C#", "Game Design", "Level Design"],
    category: "Game Development",
    description: "Developed a 2D platformer game with engaging gameplay and visually appealing graphics.",
    certificateImage: "/assets/achievements/gameCraft.jpg",
    status: "Winner"
  },
  {
    id: 5,
    competitionName: "Web Design Competition",
    year: "2022",
    rank: "3rd",
    skillsRequired: ["HTML", "CSS", "JavaScript"],
    category: "Web Development",
    description: "Replicated complex web designs into responsive and interactive websites, showcasing strong front-end development skills.",
    certificateImage: "/assets/achievements/webDesign.jpg",
    status: "Third Place"
  },
  {
    id: 6,
    competitionName: "C++ Competition ",
    year: "2022",
    rank: "1st Place",
    skillsRequired: ["C++", "OOP", "Problem Solving"],
    category: "Competitive Programming",
    description: "Solved problems using Object-Oriented Programming concepts in C++.",
    certificateImage: "/assets/achievements/cpp.jpg",
    status: "Winner"
  },
  {
    id: 7,
    competitionName: "Prabal 48-HOUR HACKATHON",
    year: "2025",
    rank: "Top 20",
    skillsRequired: ["ReactJS", "Firebase", "Web Scraping", "APIs", "ExpressJS", "NodeJS", "Flask", "Python"],
    category: "Web Development",
    description: "Built a platform to add or check online products for eco-friendliness using web scraping and APIs.",
    certificateImage: "/assets/achievements/Prabal.png",
    status: "Top Performer in PS"
  },
  {
    id: 8,
    competitionName: "Debate Competition 2k25",
    year: "2025",
    rank: "1st Place",
    skillsRequired: ["Communication", "Critical Thinking", "Teamwork", "Public Speaking", "Active Listening", "Persuasion"],
    category: "Soft Skills",
    description: "Won in a debate competition showcasing strong communication and critical thinking skills.",
    certificateImage: "/assets/achievements/Debate2k25.png",
    status: "Winner"
  },
  {
    id: 9,
    competitionName: "Argue-Mind",
    year: "2025",
    rank: "Technical Head",
    skillsRequired: ["Leadership", "Project Management", "Communication", "Critical Thinking", "Team Management", "Public Speaking"],
    category: "Soft Skills",
    description: "Built a platform to conduct online debates and quizzes, enhancing users' critical thinking and managed the technical team effectively.",
    certificateImage: "/assets/achievements/ArgueMan.png",
    status: "Management"
  }
];

export default AchievementsList;
